import {
  OPTION_AMORTIZATION_ABOLISHED,
  OPTION_AMORTIZATION_NOT_ABOLISHED,
  OPTION_ASS_AC_COMFORT,
  OPTION_ASS_AC_DEFAULT,
  OPTION_ASS_AC_PLUS,
  OPTION_ASS_OC_DEFAULT,
  OPTION_ASS_OC_PLUS,
  OPTION_NEW_REPAIR_SHOP_CONST,
  OPTION_NEW_REPAIR_SHOP_NOT_CONST,
  OPTION_REPAIR_SHOP_ESTIMATE,
  OPTION_REPAIR_SHOP_ESTIMATE_CONST_SUM,
  OPTION_REPAIR_SHOP_NOT_ESTIMATE,
  OPTION_REPAIR_SHOP_NOT_ESTIMATE_CONST_SUM,
  OPTION_SMART_DAMAGE_NATURE,
  OPTION_SMART_DAMAGE_THEFT_NATURE,
  OPTION_SMART_NATURE,
  OPTION_SMART_THEFT,
  OPTION_SMART_THEFT_NATURE
} from "@app/shared/models/cover/cover-option.model";

export const GTM_FIELDS_NAME = {
  ["licensePlateNumber"]: "numer-rejestracyjny",
  ["lp-consent"]: "informacja-dane-osobowe",
  ["vehicleType"]: "rodzaj-pojazdu",
  ["gasInstallation"]: "instalacja-gazowa",
  ["steeringWheelOnRightSide"]: "kierownica-prawa-strona",
  ["currentMileage"]: "dotychczasowy-przebieg",
  ["usage"]: "sposób-uzytkowania",
  ["mainUser"]: "glowny-uzytkownik-pojazdu",
  ["youngOwner"]: "mniej-niż-24-lata",
  ["youngestOwnerAge"]: "wiek-najmlodszego-kierowcy",
  ["pesel-"]: "pesel",
  ["peselNotKnow"]: "nie-znam-pesel",
  ["gender"]: "plec",
  ["ocInsuranceYear"]: "liczba-lat-oc",
  ["ocDamagesInLastSixYears"]: "liczba-szkod-oc",
  ["firstName-"]: "imie",
  ["lastName-"]: "nazwisko",
  ["previousLastName"]: "poprzednie-nazwisko",
  ["phoneNumber-"]: "numer-telefonu",
  ["email-"]: "adres-email",
  ["driverLicenseObtainYear"]: "rok-uzyskania-prawa-jazdy",
  ["postalCode"]: "kod-pocztowy",
  ["city"]: "miejscowosc",
  ["city-address"]: "miejscowosc",
  ["street-address"]: "ulica",
  ["autocomplete-street-address"]: "ulica",
  ["houseNumber-address"]: "numer-domu",
  ["flatNumber-address"]: "numer-lokalu",
  ["allConsentsSelect"]: "zaznaczenie-wszystkich-zgod",
  ["calculate_consent_INFO_OBLIGATION_WITH_PROFILING"]:
    "zaznaczenie-info-dane-osobowe",
  ["calculate_consent_ANTI_GROUP"]: "zaznaczenie-oswiadczenia-wykluczenia",
  ["calculate_consent_E_SERVICE_TERM"]:
    "zaznaczenie-regulamin-droga-elektroniczna",
  ["calculate_consent_CONTACT_EMAIL_MRKT"]:
    "'zaznaczenie-zgody-informacje-handlowe",
  ["calculate_consent_CONTACT_PHONE"]: "zaznaczenie-zgody-ofert-automatow",
  ["calculate_consent_PZU_DATA_SHARING_MRKT"]:
    "zaznaczenie-zgody-cele-marketingowe",
  ["kdr-checkbox"]: "karta-duzej-rodziny",
  ["largeFamilyCardNumber"]: "karta-duzej-rodziny",
  ["promotional-code-checkbox"]: "kod-promocyjny",
  ["promotionalCode"]: "kod-promocyjny",
  ["installments-checkbox"]: "raty",
  ["vin"]: "vin",
  ["isRegisteredAddressTheSameAsHomeAddress"]: "adres-zameldowania-taki-sam",
  ["isCorrespondenceAddressTheSameAsHomeAddress"]:
    "adres-korespodencyjny-taki-sam",
  ["insurer"]: "kto-zawiera-umowe",
  ["sell_consent_BUNDLE_CAR_AND_FORM"]: "zaznaczenie-prawdziwe-dane",
  ["sell_consent_IMPORTANT_INFO"]: "zaznaczenie-wazne-informacje",
  ["sell_consent_INSPECTION"]: "zaznaczenie-info-ogledziny-pojazdu",
  ["sell_consent_BUNDLE_IDD"]: "zaznaczenie-info-odstapienie-od-umowy",
  ["sell_consent_RENOUNCEMENT"]: "zaznaczenie-info-odstapienie-od-umowy",
  ["sell_consent_SELLER_INTRODUCTION"]: "zaznaczenie-info-umowa-z-link4",
  ["sell_consent_DATA_UPDATE"]:
    "zaznaczenie-akceptacja-aktualizacji-formularza",
  ["cover_3464"]: "auto-assistance",
  ["cover_8086"]: "szyby",
  ["cover_286998"]: "pomoc-kradziez",
  ["cover_282663"]: "wracaj-do-zdrowia",
  ["cover_308246"]: "auto-zastepcze-na-czas-naprawy",
  ["cover_27061"]: "smart-casco",
  ["cover_102797"]: "nnw",
  ["cover_295267"]: "pomoc-po-wypadku",
  ["cover_9353"]: "auto-assistance",
  ["cover_20218"]: "nnw",
  ["cover_110599"]: "szyby",
  ["cover_39976"]: "kluczyki",
  ["cover_293041"]: "zaznaczenie-ekocyklista",
  ["authCode"]: "wypelnienie-kod-sms",
  ["vehicleProductionYear"]: "rok-produkcji",
  ["vehicleBrand"]: "marka",
  ["vehicleModel"]: "model",
  ["vehicleVersion"]: "wersja",
  ["birthDate"]: "data-urodzenia",
  ["day-birthDate"]: "data-urodzenia",
  ["month-birthDate"]: "data-urodzenia",
  ["year-birthDate"]: "data-urodzenia",
  ["groupInputDate"]: "data-urodzenia",
  ["day-startDate"]: "data-rozpoczecia-ubezpieczenia",
  ["month-startDate"]: "data-rozpoczecia-ubezpieczenia",
  ["year-startDate"]: "data-rozpoczecia-ubezpieczenia",
  ["startDate"]: "data-rozpoczecia-ubezpieczenia",
  ["flatNumber-insurer-address"]: "umowa-inna-osoba-nrlokalu",
  ["houseNumber-insurer-address"]: "umowa-inna-osoba-nrdomu",
  ["city-insurer-address"]: "umowa-inna-osoba-miejscowosc",
  ["postalCode-insurer-address"]: "'umowa-inna-osoba-kod-pocztowy",
  ["email-insurer-email"]: "umowa-inna-osoba-mail",
  ["phoneNumber-insurer-phone"]: "umowa-inna-osoba-telefon",
  ["lastName-insurer-last-name"]: "umowa-inna-osoba-nazwisko",
  ["firstName-insurer-first-name"]: "umowa-inna-osoba-imie",
  ["pesel-insurer-pesel"]: "umowa-inna-osoba-pesel",
  ["autocomplete-street-insurer-address"]: "umowa-inna-osoba-ulica",
  ["street-insurer-address"]: "umowa-inna-osoba-ulica",
  ["ocDamagesInLastThreeYears"]: "liczba-szkod-oc-3-lata",
  ["ocDamagesInLastYear"]: "liczba-szkod-oc-6-lat",
  ["coverOptionCheckbox-3464"]: "zaznaczenie-autoassistance",
  ["coverOptionCheckbox-102797"]: "zaznaczenie-nnw",
  ["coverOptionCheckbox-20218"]: "zaznaczenie-nnw",
  ["coverInsuranceAmountCheckbox-20218"]: "zaznaczenie-nnw",
  ["coverInsuranceAmountCheckbox-102797"]: "zaznaczenie-nnw",
  ['coverOptionCheckbox-3466"']: "zaznaczenie-programpomocy",
  ["coverOptionCheckbox-27061"]: "zaznaczenie-smartcasco",
  ["coverOptionCheckbox-9353"]: "zaznaczenie-autoassistance",
  ["ownersCount"]: "ilosc-wlascicieli",
  ["option-10000"]: "wariant-nnw-10000",
  ["option-20000"]: "wariant-nnw-20000",
  ["option-50000"]: "wariant-nnw-50000",
  ["option-100000"]: "wariant-nnw-100000",
  ["option-price-0"]: "wariant-autocasco-wlasny-udzial-0",
  ["option-price-500"]: "wariant-autocasco-wlasny-udzial-500",
  ["option-price-1000"]: "wariant-autocasco-wlasny-udzial-1000",
  ["option-" + OPTION_ASS_OC_DEFAULT]: "wariant-autoassistance-default",
  ["option-" + OPTION_ASS_OC_PLUS]: "wariant-autoassistance-plus",
  ["option-" + OPTION_ASS_AC_DEFAULT]: "wariant-autoassistance-default",
  ["option-" + OPTION_ASS_AC_PLUS]: "wariant-autoassistance-plus",
  ["option-" + OPTION_ASS_AC_COMFORT]: "wariant-autoassistance-komfort",
  ["option-" + OPTION_SMART_THEFT]: "wariant-smartcasco-kradziez",
  ["option-" + OPTION_SMART_NATURE]: "wariant-smartcasco-natura",
  ["option-" + OPTION_SMART_THEFT_NATURE]: "wariant-smartcasco-kradziez-natura",
  ["option-" + OPTION_SMART_DAMAGE_NATURE]:
    "wariant-smartcasco-zniszczenia-natura",
  ["option-" + OPTION_SMART_DAMAGE_THEFT_NATURE]:
    "wariant-smartcasco-zniszczenia-kradziez-natura",
  ["option-" + OPTION_REPAIR_SHOP_ESTIMATE]: "wariant-ac-kosztorys-zmienna",
  ["option-" + OPTION_REPAIR_SHOP_ESTIMATE_CONST_SUM]:
    "wariant-ac-kosztorys-stala",
  ["option-" + OPTION_REPAIR_SHOP_NOT_ESTIMATE]: "wariant-ac-ASO-zmienna",
  ["option-" + OPTION_REPAIR_SHOP_NOT_ESTIMATE_CONST_SUM]:
    "wariant-ac-ASO-stala",
  ["option-" + OPTION_NEW_REPAIR_SHOP_NOT_CONST]: "wariant-ac-warsztat-zmienna",
  ["option-" + OPTION_NEW_REPAIR_SHOP_CONST]: "wariant-ac-warsztat-stala",
  ["option-" + OPTION_AMORTIZATION_ABOLISHED]: "wariant-amortyzacja-zniesiona",
  ["option-" + OPTION_AMORTIZATION_NOT_ABOLISHED]:
    "wariant-amortyzacja-niezniesiona",
  ["postalCode-registeredAddress"]: "adres-zameldowania-kod-pocztowy",
  ["city-registeredAddress"]: "adres-zameldowania-miasto",
  ["street-registeredAddress"]: "adres-zameldowania-ulica",
  ["houseNumber-registeredAddress"]: "adres-zameldowania-nrdomu",
  ["flatNumber-registeredAddress"]: "adres-zameldowania-nrlokalu",
  ["postalCode-correspondenceAddress"]: "adres-korespondencyjny-kod-pocztowy",
  ["city-correspondenceAddress"]: "adres-korespondencyjny-miasto",
  ["street-correspondenceAddress"]: "adres-korespondencyjny-ulica",
  ["houseNumber-correspondenceAddress"]: "adres-korespondencyjny-nrdomu",
  ["flatNumber-correspondenceAddress"]: "adres-korespondencyjny-nrlokalu",
  ["acInsuranceYears"]: "liczba-lat-ubezpieczenia-ac",
  ["acDamagesInLastSixYears"]: "liczba-szkod-ac-6-lat",
  ["acDamagesInLastThreeYears"]: "liczba-szkod-ac-3-lata",
  ["acDamagesInLastYear"]: "liczba-szkod-ac"
};
